export const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3000";
export const APP_URL =
  import.meta.env.VITE_APP_URL ||
  import.meta.env.VITE_API_URL ||
  "http://localhost:3000";
export const CABLE_URL =
  import.meta.env.VITE_CABLE_URL || "ws://localhost:3000";
export const NODE_ENV = import.meta.env.VITE_NODE_ENV || "development";
export const LOCALE = import.meta.env.VITE_LOCALE || "pt-BR";
export const CREDENTIALS_KEY = "session";
export const BUGSNAG_API_KEY = import.meta.env.VITE_BUGSNAG_API_KEY || "";
export const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY || "";
export const BUILD_ID = import.meta.env.VITE_BUILD_ID || "dev";
// PostHog project API key is public (client-side capture only) — the default
// mirrors the hardcoded GTM/Pixel/Clarity tags so it works without a per-env
// config var, while VITE_POSTHOG_KEY still allows an override.
export const POSTHOG_KEY =
  import.meta.env.VITE_POSTHOG_KEY ||
  "phc_ufRb9J3MM6x5yuARSjXLgYZqHG5BumnznehZpMjhScPb";
